<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsImport-advertisingData',
  components: { PageTable },
}
</script>
